import { useTranslation } from '../../../application/hooks/useTranslation';
import type { MonthlyBucket } from '../../../domain/calculators/commissions';
import { formatMonthKey } from '../../../domain/formatters/date';
import { AmountDisplay } from '../ui/AmountDisplay';

export interface MonthlyEarningsTableProps {
  data: MonthlyBucket[];
  onSelectMonth: (key: string) => void;
}

/** Text alternative to the chart; each month is a button that sets the ledger month filter. */
export function MonthlyEarningsTable({ data, onSelectMonth }: MonthlyEarningsTableProps) {
  const { t, locale } = useTranslation();
  return (
    <div className="table-wrap">
      <table className="data" data-testid="monthly-table">
        <caption className="sr-only">{t('commissions.monthly')}</caption>
        <thead>
          <tr>
            <th scope="col">{t('commissions.tableMonth')}</th>
            <th scope="col">{t('commissions.booking')}</th>
            <th scope="col">{t('commissions.installment')}</th>
          </tr>
        </thead>
        <tbody>
          {data.map((b) => (
            <tr key={b.key}>
              <th scope="row">
                <button type="button" className="link-button tap" onClick={() => onSelectMonth(b.key)}>
                  {formatMonthKey(b.key, locale)}
                </button>
              </th>
              <td><AmountDisplay amount={b.booking} /></td>
              <td><AmountDisplay amount={b.emi} /></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
